/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-03-12 17:34:44
 * @LastEditors: Luke Z
 * @LastEditTime: 2021-03-29 18:29:44
 * @FilePath: /unifyxp-v2-store-portal/src/pages/SalesChannelContentEditor/SalesChannelEditorProductSearch/RouteBlock/index.tsx
 */

import React from 'react';
import { getI18nFromGeneral } from '@/src/tools/tools';
import _RouteBlock from 'src/constrains/RouterBlock/RouterBlock';

const RouteBlock = (props) => {
  const { hasModified } = props;

  return (
    <_RouteBlock
      onConfirm={(f) => f()}
      okText={getI18nFromGeneral('general.commonHeader.discard_text')}
      active={hasModified}
      title={getI18nFromGeneral('general.commonHeader.discard_header')}
      content={getI18nFromGeneral('general.commonHeader.discard_content')}
    />
  );
};
export default RouteBlock;
